import ReportDeepDive from './reportDeepDiveNewV2'
export default ReportDeepDive
